// src/services/identity/identityApi.ts

import baseApi from "../../lib/baseApi";
import type {
  IdentityEligibilityDTO,
  IdentityStartPayload,
  IdentityStartResponseDTO,
  IdentityStatusDTO,
} from "../../types/identity/identityTypes";

// Identity API service
const identityApi = {
  // Get eligibility state
  async fetchEligibility(): Promise<IdentityEligibilityDTO> {
    const response = await baseApi.get("/accounts/identity/eligibility/");
    return response.data;
  },

  // Get identity status
  async fetchStatus(): Promise<IdentityStatusDTO> {
    const response = await baseApi.get("/accounts/identity/status/");
    return response.data;
  },

  // Start verification flow
  async startVerification(
    payload?: IdentityStartPayload
  ): Promise<IdentityStartResponseDTO> {
    const response = await baseApi.post("/accounts/identity/start/", payload || {});
    return response.data;
  },
};

export default identityApi;